import React from "react";
import { TimezoneAbbreviations } from "../common/Timezones";

interface TimezoneGutterHeaderProps {
  viewTimezone?: string;
  secondaryTimezone?: string;
  dualTimezoneEnabled?: boolean;
}

const TimezoneGutterHeader: React.FC<TimezoneGutterHeaderProps> = ({
  viewTimezone,
  secondaryTimezone,
  dualTimezoneEnabled,
}) => {
  if (
    !dualTimezoneEnabled ||
    !secondaryTimezone ||
    !viewTimezone ||
    secondaryTimezone === viewTimezone
  ) {
    return null;
  }

  const getShortAbbreviation = (timezone: string) => {
    const fullAbbrev = TimezoneAbbreviations[timezone];
    if (fullAbbrev) {
      return fullAbbrev.split(" - ")[0];
    }
    return timezone.split("/").pop() || timezone;
  };

  const primaryTzAbbr = getShortAbbreviation(viewTimezone);
  const secondaryTzAbbr = getShortAbbreviation(secondaryTimezone);

  return (
    <div className="timezone-gutter-header">
      <div className="timezone-column secondary-timezone">
        {secondaryTzAbbr}
      </div>
      <div className="timezone-column primary-timezone">{primaryTzAbbr}</div>
    </div>
  );
};

export default TimezoneGutterHeader;
